var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.badgeTags, function (badge) {
      return _c("div", { key: badge, staticClass: "product-badge" }, [
        _vm._v("\n    " + _vm._s(_vm.getBadgeText(badge)) + " \n  "),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }